export const LAYOUT = {
  BORDER_RADIUS: '8px',
  BORDER_RADIUS_PILL: '1rem',
  BORDER_RADIUS_ROUND: '100px',
  BORDER_RADIUS_CIRCLE: '50%',
}
